import { Button, Grid, Tooltip, Typography } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"
import { GraphEditMode } from "@features/graph/graphViewModel"
import { getEligibleWhatIfContractOptions } from "@features/run/RunModelForm/helpers"
import { useAtomValue } from "jotai"
import { loggedInUserAtom, permissionsAtom } from "@store/authAtoms"
import PlayCircleOutlineSharpIcon from "@mui/icons-material/PlayCircleOutlineSharp"
import FileDownloadIcon from "@mui/icons-material/FileDownload"
import FileUploadIcon from "@mui/icons-material/FileUpload"
import LockIcon from "@mui/icons-material/Lock"
import { GraphDto } from "@custom-types/graphs"

export type CreateScenarioModeButtonsProps = {
  graphInfo: GraphDto | undefined
  familyKey: string
  editMode: GraphEditMode
  onEdit: (value: GraphEditMode) => void
  onExportParameters: () => void
  onImportParameters: () => void
  onValidate: () => void
  onSample: () => void
}

const CreateScenarioModeButtons = ({
  graphInfo,
  familyKey,
  editMode,
  onEdit,
  onExportParameters,
  onImportParameters,
  onSample,
  onValidate,
}: CreateScenarioModeButtonsProps) => {
  const permissions = useAtomValue(permissionsAtom)
  const contractOptions = getEligibleWhatIfContractOptions(familyKey, permissions)
  const user = useAtomValue(loggedInUserAtom)

  const checkDisabled = function () {
    return (
      contractOptions.length == 0 &&
      !(graphInfo?.creator_email === user?.email && graphInfo?.owner_group_key === "private")
    )
  }
  const isDisabled = checkDisabled()
  const isEditing = editMode === GraphEditMode.SCENARIO

  const handleEdit = () => {
    if (!isEditing) {
      onEdit(GraphEditMode.SCENARIO)
    } else {
      onEdit(GraphEditMode.OFF)
    }
  }
  return (
    <>
      <Grid item>
        <Tooltip title="Edit graph">
          <Button
            startIcon={isEditing ? <LockIcon /> : <EditIcon />}
            variant="contained"
            sx={{ background: "#2196f3" }}
            onClick={handleEdit}
            disabled={isDisabled}
          >
            <Typography className={"hideNarrow1400"}>{isEditing ? "Lock" : "Edit"}</Typography>
          </Button>
        </Tooltip>
      </Grid>

      <Grid item>
        <Tooltip title="Export parameters">
          <Button
            startIcon={<FileDownloadIcon />}
            variant="contained"
            sx={{ background: "black" }}
            onClick={() => onExportParameters()}
            disabled={isDisabled}
          >
            <Typography className={"hideNarrow1400"}>Export parameters</Typography>
          </Button>
        </Tooltip>
      </Grid>

      <Grid item>
        <Tooltip title="Import parameters">
          <Button
            startIcon={<FileUploadIcon />}
            variant="contained"
            sx={{ background: "black" }}
            onClick={() => onImportParameters()}
            disabled={isDisabled}
          >
            <Typography className={"hideNarrow1400"}>Import parameters</Typography>
          </Button>
        </Tooltip>
      </Grid>

      <Grid item>
        <Tooltip title="Sample">
          <Button
            variant="contained"
            startIcon={<PlayCircleOutlineSharpIcon />}
            disabled={isDisabled}
            color="error"
            onClick={() => onSample()}
          >
            <Typography className={"hideNarrow1400"}>Sample</Typography>
          </Button>
        </Tooltip>
      </Grid>
    </>
  )
}

export default CreateScenarioModeButtons
